var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup-background"},[_c('div',{staticClass:"popup-foreground"},[_c('ClickAwayHandler',{staticClass:"popup-container",on:{"clicked-away":function($event){return _vm.$emit('cancel')}}},[_vm._t("default")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }